<template>
  <div class="card">
    <div class="card-body">
      <slot name="menu">
        <ListMenu
          :id="`${id}-menu`"
          :item="item"
          :eventBus="eventBus"
          :section="section"
          class="card-menu"
        />
      </slot>
      <div class="card-details">
        <div class="card-title">{{ item.name }}</div>
        <div class="card-subtitle">{{ userId }}</div>
        <div class="card-text">
          Email: {{ item.email }}
          <br />
          Phone: {{ item.phone }}
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import ListCardMixin from "mixins/ListCard";
import ListMenu from "./ListMenu";
export default {
  mixins: [ListCardMixin],
  components: { ListMenu },
  props: {
    section: { type: String, default: "training" },
  },
  computed: {
    userId() {
      if (!!this.item.hvac_id) {
        return `HVAC ID: ${this.item.hvac_id}`;
      } else if (!!this.item.aviator_id) {
        return `Aviator ID: ${this.item.aviator_id}`;
      } else {
        return `MLC ID: ${this.item.id}`;
      }
    },
  },
};
</script>
